import { BillingActionNames, BillingActionTypes } from "./actions";
import { IBilling } from "./interfaces";

export type IBillingState = IBilling;

// @ts-expect-error TS(2322): Type 'null' is not assignable to type 'IBilling'.
export const initialState: IBillingState = null;

export const billingReducer = (state: IBillingState = initialState, action: BillingActionTypes): IBillingState => {
  switch (action.type) {
    case BillingActionNames.FETCH_BILLING_INFO_SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case BillingActionNames.UPDATE_BILLING_INFO_SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }

    default:
      return state;
  }
};
